import{supabase}from'../api/supabaseClient.js';import{getCurrentUser}from'./liveData.js';
function client(){if(!supabase)throw new Error('Supabase frontend environment is not configured.');return supabase}
const mutable=['target_low','target_high','status','priority','why_return','thesis_state','valuation_state','sector_heat','stock_sheep','trigger_notes','move_cause_class','move_confirmation_state','move_cause_note','is_active'];
export async function updateReentryItem(item,patch,note=''){
 if(!item?.id)throw new Error('REENTRY_ID_REQUIRED');
 if(!item.updated_at)throw new Error('Reload re-entry before editing.');
 const user=await getCurrentUser();if(!user)throw new Error('Authentication required.');
 const allowed={};for(const k of mutable)if(k in patch&&patch[k]!==undefined)allowed[k]=patch[k];
 const{data,error}=await client().rpc('update_reentry_with_revision',{
  p_id:item.id,p_expected_updated_at:item.updated_at,p_patch:allowed,p_note:String(note||'').trim()||null
 });
 if(error){if(error.code==='40001')throw new Error('This re-entry was changed elsewhere. Reload before saving again.');throw error;}
 if(!data?.id)throw new Error('REENTRY_SAVE_FAILED');return data;
}
